import {
  GET_CHALLENGES,
  GET_CHALLENGES_SUCCESS,
  GET_CHALLENGES_ERROR,
  GET_MY_COHORTS,
  GET_MY_COHORTS_SUCCESS,
  GET_MY_COHORTS_ERROR,
} from './constants';

export function getChallenges() {
  return {
    type: GET_CHALLENGES,
  };
}

export function getChallengesSuccess(payload) {
  return {
    type: GET_CHALLENGES_SUCCESS,
    payload,
  };
}

export function getChallengesError(err) {
  return {
    type: GET_CHALLENGES_ERROR,
    err,
  };
}

export function getMyCohorts() {
  return {
    type: GET_MY_COHORTS,
  };
}

export function getMyCohortsSuccess(payload) {
  return {
    type: GET_MY_COHORTS_SUCCESS,
    payload,
  };
}

export function getMyCohortsError(err) {
  return {
    type: GET_MY_COHORTS_ERROR,
    err,
  };
}
